module.exports = __webpack_public_path__ + "static/media/autodesk-icon-512.742b844e.png";